import React from "react";
import type { ReactNode } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";

type ConfirmDeleteDialogProps = {
  title?: string;
  description?: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export const ConfirmDeleteDialog = ({
  title,
  description,
  open,
  onOpenChange,
  onConfirm,
}: ConfirmDeleteDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-no-dnd>
        <AlertDialogHeader>
          <AlertDialogTitle>{title || t("confirm_delete.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {description || t("confirm_delete.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("confirm_delete.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-delete-dialog-confirm-button"
            className={buttonVariants({ variant: "destructive" })}
            onClick={() => onConfirm()}
          >
            {t("confirm_delete.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
